
<v-menu
    v-model="menu"
    offset-y
    nudge-bottom="11"
    nudge-left="10"
    min-width="240"
    :close-on-content-click="false"
>
    <template v-slot:activator="{ on, attrs }" >
        <a
            v-bind="attrs"
            v-on="on"
        >
            <v-icon color="white" size="28" style="width: 18px;">{{ menu ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
        </a>
    </template>

    <div class="white pa-2">
        <div v-for="(email,index) in emailList" :key="index" class="pt-1 pb-1">
            <v-checkbox
                v-model   = "email.selected"
                :ripple   = "false"
                :readonly = "!email.valid"
                class     = "mt-0 pt-0"
                hide-details
            >
                <template v-slot:label>
                    <span :class="email.valid ? '' : 'error--text'">{{ email.address }}</span>
                </template>
            </v-checkbox>
        </div>
    </div>
</v-menu>
